// @flow
import * as React from 'react'

const setLogoDark = (open, when, set) => {
  if (open === when) {
    setTimeout(() => set(open), 300)
  } else {
    set(open)
  }
}

export function useSetDebounce(open: boolean, when: boolean = false) {
  const [isLogoDark, _setLogoDark] = React.useState(open)

  React.useEffect(() => {
    setLogoDark(open, when, _setLogoDark)
  }, [open, _setLogoDark, when])

  return isLogoDark
}
